module.exports = __webpack_public_path__ + "img/union.739256dd.svg";